import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import MonogramStepInitials from "./monogram-step-initials";
import MonogramStepPosition from "./monogram-step-position";
import MonogramStepFont from "./monogram-step-font";
import MonogramStepSize from "./monogram-step-size";
import MonogramStepColor from "./monogram-step-color";
import { positions } from "./constants";

export default function MonogramSteps({
  product,
  globalConfig,
  config,
  setConfig,
  setVisibleStep,
}) {
  const commonProps = { product, globalConfig, config, setConfig };

  const steps = [
    {
      title: () => window.theme.localeStrings.monogram.choose_placement,
      component: (
        <MonogramStepPosition
          {...commonProps}
          setVisible={(visible) => setVisibleStep({ i: 0, visible })}
        />
      ),
    },
    {
      title: () => {
        const { one, other } =
          window.theme.localeStrings.monogram.enter_initials;
        const numberOfInitials = parseInt(
          product.monogramSettings.numberOfInitials,
        );
        const message = numberOfInitials === 1 ? one : other;
        return message.replace("[count]", numberOfInitials);
      },
      enabled: () => true,
      component: <MonogramStepInitials {...commonProps} />,
    },
    {
      title: () => window.theme.localeStrings.monogram.choose_font,
      component: (
        <MonogramStepFont
          {...commonProps}
          setVisible={(visible) => setVisibleStep({ i: 2, visible })}
        />
      ),
    },
    {
      title: () => window.theme.localeStrings.monogram.choose_size,
      component: (
        <MonogramStepSize
          {...commonProps}
          setVisible={(visible) => setVisibleStep({ i: 3, visible })}
        />
      ),
    },
    {
      title: () => window.theme.localeStrings.monogram.choose_color,
      component: <MonogramStepColor {...commonProps} />,
    },
  ];

  return steps;
}
